import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import IconButton from "@material-ui/core/IconButton"

import moment from "moment";

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {
  ApolloMessage,
  setLoadingMessage,
  setErrorMessageTypeAll,
} from "../../atom/Apollo_Mesasge";
import {
  apollo_report_download_path,
} from "../../atom/Apollo_links";
import {ApolloExpired} from "../../atom/Apollo_Expired";
import {
  RESULT_CODE,
  MSG,
  ZERO,
  REPORT_DOWNLOAD_EXPIRATION_DATE,
  REPORT_STATUS,
} from "../../common/Apollo_CommonConst_Beta";
import { Report } from "../../pages/REPORT/ReportModel";
import { Buffer } from 'buffer';

const ApolloReportDownload: React.FC<{ report: Report }> = ({ report }) => {

  // useContext
  const { data: msg, setmsg } = React.useContext(ApolloMessage);

  // history
  const history = useHistory();

  // useState
  const [download, setDownload] = useState(0);

  // 今日
  const today = moment().startOf('day');
  // レポート作成日(抽出日)
  const createdAt = moment(report.extractedAt);
  // レポートダウンロードの有効期限日
  const expiredAt = createdAt.clone().add(REPORT_DOWNLOAD_EXPIRATION_DATE - 1, 'days');

  let disabled = false;
  let title = `CSVダウンロード\n${expiredAt.format('YYYY-MM-DD')}までダウンロード可能`;
  let color: 'inherit' | 'primary' | 'secondary' | 'action' | 'disabled' | 'error' = 'primary';

  if (report.reportStatus == REPORT_STATUS.RECORD_NOT_FOUND) {
    // データ0件の場合
    disabled = true;
    title = 'レポート作成対象が存在しないため、ダウンロード出来ません'
    color = 'disabled';
  } else if (!report.reportFileUrl || !report.extractedAt) {
    // レポートが作成されていない場合
    disabled = true;
    title = 'レポートが作成されていないため、ダウンロード出来ません'
    color = 'disabled';
  } else if (report.reportStatus == REPORT_STATUS.FAILURE) {
    // 作成失敗の場合
    disabled = true;
    title = 'レポート出力に失敗しました。再実行ボタンを押してください'
    color = 'disabled';
  } else if (expiredAt.diff(today) < ZERO) {
    disabled = true;
    title = '期限切れのため、ダウンロード出来ません'
    color = 'disabled';
  }

  // 取得データをCSVデータで返却する
  const dataToCsvBlob = (data: any): Blob => {
    // BASE64でコード
    let buf = Buffer.from(data, 'base64');

    const blob = new Blob([buf], {
        type: 'text/csv'
    })
    return blob
  }

  useEffect(() => {
    if (download === ZERO) return;
    setmsg(setLoadingMessage(msg, true));
    const url = apollo_report_download_path + "/" + report.reportId;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === RESULT_CODE.SUCCESS) {
        setmsg(setLoadingMessage(msg, false));
        createCsv(response.data.result);
      } else {
        setmsg(setErrorMessageTypeAll(msg, MSG.ERROR_GET_REPORT_DOWNLOAD));
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, MSG.ERROR_GET_REPORT_DOWNLOAD, msg, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [download]);

  // ダウンロードハンドラ
  const handleDownload = () => {
    setDownload(download+1);
  }

  const createCsv = (data:any) => {
    const blob = dataToCsvBlob(data)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = report.reportFileName ? report.reportFileName : "none.csv";
    link.click();
  }

  return (
    <Tooltip title={title} placement="bottom-end">
      <span>
        <IconButton
          aria-label="download"
          onClick={() => handleDownload()}
          disabled={disabled}
        >
          <CloudDownloadIcon color={color} />
        </IconButton>
      </span>
    </Tooltip>
  )
}
export default ApolloReportDownload;